 
import React, { FC, useState, useEffect, memo, useRef } from "../../../lib/teact/teact";
import DropdownMenu from "../../ui/DropdownMenu";
import ListItem from "../../ui/ListItem";
import MenuItem from "../../ui/MenuItem";
import SearchInput from "../../ui/SearchInput";
import { enumDauVaoTinNhan } from "../commontypes";
import { GetAllMesssagesByIdsAndroid } from "../tdlib/tdlib";
import { LotMessage } from "../types/types";
import { GetUserFullInfo } from "../utils/common";
import { NativeRestApi } from "../websocket/nativeRestApi";
import PhoneMessages from "./phoneMessages";
import ConversationItem from "./ui/ConversationItem";

type OwnProps = {
    onTransMessagesFromSelectedToParse: (messages: any[]) => void;
}
enum DisPlayType {
    displayConversation,
    displayMessages,
}
const PhoneConvs: FC<OwnProps> = ({
    onTransMessagesFromSelectedToParse,
}) => {
    const userInfo = GetUserFullInfo();
    const [state, setState] = useState({
        conversations: [] as any[],
        dispplayType: DisPlayType.displayConversation,
        curThreadId: -1,
        inSelectChatMode: false,
        selectedChatIds: [] as any[],
        chatListFull: [] as any,
        curConversation: {} as any,
        
    })
    const headerRef = useRef()
    useEffect(() => {
        NativeRestApi.getConversations().then(res => {
            if (res && res.message) {
                const data = JSON.parse(res.message)
                setState(prev => ({ ...prev, conversations: data }))
            }
        })
    }, [])
    function displayMessagesOfConversation(convId: number) {
        setState(prev => ({
            ...prev, dispplayType: DisPlayType.displayMessages,
            curThreadId: convId,
        }))
    }
    function displayConversation() {
        setState(prev => ({
            ...prev, dispplayType: DisPlayType.displayConversation,

        }))
    }
    function khopSoLuongTin(chatIds: number[] | string[]) {

    }
    function handleChangeSelectChatMode(select: boolean) {
        setState(prev => {
            if (prev.inSelectChatMode) {
                return {
                    ...prev, inSelectChatMode: !prev.inSelectChatMode,
                    selectedChatIds: []
                }
            }
            return { ...prev, inSelectChatMode: !prev.inSelectChatMode }
        })
    }
  
    return (
        <>

            {
                state.dispplayType == DisPlayType.displayConversation ?
                    <div>

                        <div className="header" ref={headerRef}>
                            <div className="search">
                                <SearchInput onChange={(e) => {
                                    //debouncedSerchChatList(e)
                                    //setState(prev => ({ ...prev, searchFilter: e }))
                                }}
                                //value={state.searchFilter}
                                />
                            </div>
                            {state.inSelectChatMode &&
                                <div>
                                    đã chọn {state.selectedChatIds.length}
                                </div>
                            }
                            <div className="right-panel">
                                {
                                    // state.selectedChatIds.length > 0 &&
                                    // <Button round size="smaller"
                                    //     color={state.inSelectChatMode ? "primary" : "translucent"}
                                    //     onClick={() => {

                                    //     }}
                                    // >
                                    //     <i className="icon icon-message" />
                                    // </Button>
                                }
                                <DropdownMenu positionX="right">
                                    {
                                        state.inSelectChatMode &&
                                        <>
                                            <MenuItem
                                                onClick={() => {

                                                    setState(prev => ({ ...prev, openTransDialog: true }))
                                                    if (userInfo.dauVaoTinNhan == enumDauVaoTinNhan.android) {
                                                        GetAllMesssagesByIdsAndroid(state.selectedChatIds).then((res: LotMessage[]) => {
                                                            onTransMessagesFromSelectedToParse(res)
                                                        })
                                                    } 

                                                    

                                                }}
                                            >
                                                Phân tích hội thoại đã chọn
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    //khopSoLuongTin()
                                                }}
                                            >
                                                Khớp số lượng tin
                                            </MenuItem>
                                        </>
                                    }
                                    {state.selectedChatIds.length == 0 && !state.inSelectChatMode &&
                                        <MenuItem
                                            onClick={() => {
                                                const chatIds: string[] = []
                                                for (let chat of state.chatListFull) {
                                                    chatIds.push(chat.id)
                                                }
                                                khopSoLuongTin(chatIds)
                                            }}
                                        >
                                            Khớp tin tất cả các khách
                                        </MenuItem>
                                    }
                                    <MenuItem onClick={() => {
                                        const select = !state.inSelectChatMode
                                        handleChangeSelectChatMode(select)
                                    }}
                                    >
                                        Chọn hội thoại
                                    </MenuItem>
                                    
                                </DropdownMenu>
                            </div>
                        </div>
                        <div>
                            {
                                state.conversations.map((it, index) => {
                                    return <div key={"convs" + index}>
                                        <ListItem onClick={() => {
                                            //const threadId = Number(it.id)
                                            //displayMessagesOfConversation(threadId)
                                        }}>
                                            <ConversationItem convItemData={it}
                                                selected={state.selectedChatIds.includes(it.id)}
                                                onClick={() => {

                                                    const threadId = Number(it.id)
                                                    setState(prev => ({ ...prev, curConversation: it }))
                                                    displayMessagesOfConversation(threadId)
                                                }}
                                                onChangeSelected={() => {
                                                    const tmp: any[] = state.selectedChatIds;
                                                    let result: any[] = []
                                                    if (tmp.includes(it.id)) {
                                                        result = tmp.filter((id: any) => {
                                                            return id != it.id
                                                        })
                                                    } else {
                                                        result = tmp;
                                                        result.push(it.id)
                                                    }
                                                    if (result.length > 0)
                                                        setState(prev => ({ ...prev, selectedChatIds: result }))
                                                    else
                                                        setState(prev => ({ ...prev, selectedChatIds: result, inSelectChatMode: false }))
                                                }}
                                                inSelectMode={state.inSelectChatMode} />
                                        </ListItem>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    : <PhoneMessages threadId={state.curThreadId}
                        conversation={state.curConversation}
                        onBackToConversation={() => {
                            displayConversation()
                        }}
                        onTransMessagesFromSelectedToParse={onTransMessagesFromSelectedToParse}
                    />
            }
        </>
    )
}
export default memo(PhoneConvs)